// pages/products/signage/GuideSign.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection,
  UsageGrid,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const GuideSign = () => {
  
  return (
    <>
      <HeroSection
        title={`교통안전표지판`}
        subtitle={`도로교통 안전을 위해 각종 알림 표지를 제공합니다`}
        backgroundImage="/images/products/signage/guide-sign1.webp"
        breadcrumbs={[
            { label: '홈', path: '/' },
            { label: '도로 안내표지시스템', path: '/products/signage' },
            { label: '교통안전표지판' }, // 현재 페이지는 path 없음
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`안전 사고 예방을 위한`}
        title={`교통안전표지판`}
        description={
          <>
            운전자의 안전하고 원활한 도로 이용을 위해  <strong>경계표지</strong>로 주행 범위와 제한 구역 안내, {' '}
            <strong>이정표지</strong>로 목적지와 거리 정보 제공, <strong>방향표지</strong>로 차로와 진행 방향에 대한 직관적인 안내, {' '}
            <strong>노선표지</strong>로 도로 번호와 노선 안내, <strong>안내표지</strong>로 휴게소, 관광지, 병원 등 편의 시설 정보를 제공하고 있습니다.
          </>
        }
        images={[
          '/images/products/signage/guide-sign2.jpeg',
          '/images/products/signage/guide-sign3.jpg',
          '/images/products/signage/guide-sign4.jpg',
        ]}
        badgeImages={[
            "/images/logo/Nara.webp",
        ]}
      />

      <SectionDivider />

      <InfoSection title="표지판 종류">
        <UsageGrid
          columns={1}
          items={[
            {
              image: '/images/products/signage/guide-sign-new.webp',
            },
          ]}
        />
      </InfoSection>


      <ProductDetailNav
        category="signage"
        currentPath="/products/signage/guide-sign"
        listPath="/products/signage"
      />


      <CTASection />
    </>
  );
};

export default GuideSign;
